// An .idml dropped on another lesson page (the sections page) on its way to the print tools page,
// which takes it on mount and analyzes it at once, as the legacy sections page's tab flip did.
// Module state rather than router state: a File does not survive history serialization everywhere.
let pending: File | null = null;

export const stashIdml = (file: File) => {
  pending = file;
};

export const takeIdml = () => {
  const file = pending;
  pending = null;
  return file;
};
